import { createOnboarding } from "~/ui/onboarding";
import { node } from "~/util/dom";
import { setItem, getItem } from "~/es6/localstorage";
import { _ } from "~/route/globals";
import { DEFAULT_VALUE_USER_SPEED } from "~/util/constants";
import { store } from "~/state/store";

const MAX_SHOW = 3;
const STORAGE_ITEM_NAME = "userSpeedOnboardingVIsible";
const ALLOWED_USER_SPEED_CRITERIONS = Object.keys(DEFAULT_VALUE_USER_SPEED);
let timeoutToSetLocalStorage = null;

export function createUserSpeedOnboarding(index: number): HTMLDivElement {
	let onboarding = null;
	const { user } = store.getState().user;

	let numOfVisible = user.premium ? MAX_SHOW : parseInt(getItem(STORAGE_ITEM_NAME)) || 0;

	if (numOfVisible < MAX_SHOW) {
		const criterion = Mapy.CML.state.route.params.criterion;

		if (criterion && ALLOWED_USER_SPEED_CRITERIONS.includes(criterion.toString())) {
			const text = node("p");
			const button = node("button", { type: "button", className: "route-user-speed-onboarding__button" }, _("profile.settings.userspeed.onboarding.href"));


			onboarding = createOnboarding({
				className: "route-user-speed-onboarding",
				onClose: () => {
					setItem(STORAGE_ITEM_NAME, MAX_SHOW.toString());
				},
			});

			switch (criterion) {
				case 121:
					text.innerHTML = _("profile.settings.userspeed.onboarding.6");
					break;

				case 122:
					text.innerHTML = _("profile.settings.userspeed.onboarding.2");
					break;

				case 123:
					text.innerHTML = _("profile.settings.userspeed.onboarding.3");
					break;

				case 124:
					text.innerHTML = _("profile.settings.userspeed.onboarding.7");
					break;

				case 125:
					text.innerHTML = _("profile.settings.userspeed.onboarding.8");
					break;

				case 131:
				case 132:
					text.innerHTML = _("profile.settings.userspeed.onboarding.1");
					break;

				case 133:
					text.innerHTML = _("profile.settings.userspeed.onboarding.10");
					break;

				case 134:
					text.innerHTML = _("profile.settings.userspeed.onboarding.11");
					break;

				case 141:
					text.innerHTML = _("profile.settings.userspeed.onboarding.5");
					break;

				case 142:
					text.innerHTML = _("profile.settings.userspeed.onboarding.9");
					break;

				case 143:
				case 144:
					text.innerHTML = _("profile.settings.userspeed.onboarding.4");
					break;

				default:
					break;
			}

			button.addEventListener("click", event => {
				event.preventDefault();

				const actualUser = store.getState().user.user;

				if (actualUser.state === "green") {
					Mapy.getComponent("profile").activate();
					Mapy.getComponent("settings").activate();
				} else {
					Mapy.getComponent("login").open({
						analyticsData: {
							loginOrigin: "userspeed",
						},
						motivation: "none",
					}).then(() => {
						Mapy.getComponent("profile").activate();
						Mapy.getComponent("settings").activate();
					}, () => {});
				}
			});

			onboarding.append(text, " ", button);

			if (index === 0) {
				if (timeoutToSetLocalStorage) {
					clearTimeout(timeoutToSetLocalStorage);

					timeoutToSetLocalStorage = null;
				}

				timeoutToSetLocalStorage = setTimeout(() => {
					numOfVisible++;
					setItem(STORAGE_ITEM_NAME, numOfVisible.toString());
				}, 300);
			}
		}
	}


	return onboarding;
}
